import React from "react";
import "./LegalPages.css";

const UsoCookies = () => (
  <div className="legal-page">
    <h1>Uso de Cookies</h1>

    <section>
      <h2>1. ¿Qué son las cookies?</h2>
      <p>
        Las cookies son archivos que se descargan en tu dispositivo al acceder a determinadas páginas web. Permiten almacenar y recuperar información sobre la navegación de un usuario y, dependiendo de la información que contengan y del uso que se haga de tu equipo, pueden utilizarse para reconocerte.
      </p>
    </section>

    <section>
      <h2>2. Tipos de cookies utilizadas</h2>
      <p>
        El sitio web www.sparklingtech.es utiliza las siguientes categorías de cookies:
      </p>
      <ul>
        <li><b>Cookies técnicas (necesarias)</b>: Permiten la navegación a través del sitio web y el uso de las diferentes opciones o servicios que en él existen.</li>
        <li><b>Cookies de análisis</b>: Recopilan datos estadísticos anónimos para entender cómo interactúan los usuarios con la web.</li>
        <li><b>Cookies de personalización</b>: Permiten recordar información para personalizar la experiencia del usuario (por ejemplo, idioma o región).</li>
      </ul>
    </section>

    <section>
      <h2>3. Consentimiento</h2>
      <p>
        Al acceder por primera vez al sitio web, verás un banner donde se te informa del uso de cookies. Puedes aceptarlas, rechazarlas o configurarlas. Las cookies no necesarias solo se instalarán si tú lo autorizas expresamente.
      </p>
      <p>
        Puedes cambiar o retirar tu consentimiento en cualquier momento desde la sección "Configuración de Cookies" disponible en el pie de página del sitio web.
      </p>
    </section>

    <section>
      <h2>4. Gestión y eliminación de cookies</h2>
      <p>
        Puedes permitir, bloquear o eliminar las cookies instaladas en tu dispositivo configurando las opciones del navegador:
      </p>
      <ul>
        <li>Chrome: <a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a></li>
        <li>Firefox: <a href="https://support.mozilla.org/es/kb/Borrar%20cookies">https://support.mozilla.org/es/kb/Borrar%20cookies</a></li>
        <li>Safari: <a href="https://support.apple.com/es-es/HT201265">https://support.apple.com/es-es/HT201265</a></li>
        <li>Edge: <a href="https://support.microsoft.com/es-es/help/4027947">https://support.microsoft.com/es-es/help/4027947</a></li>
      </ul>
    </section>

    <section>
      <h2>5. Transferencias de datos a terceros</h2>
      <p>
        Algunas cookies (como las de Google Analytics) pueden implicar transferencia de datos a servidores de EE.UU. o fuera del Espacio Económico Europeo. En ese caso, se adoptarán garantías adecuadas de conformidad con lo establecido en el RGPD.
      </p>
    </section>

    <section>
      <h2>6. Actualización de esta política</h2>
      <p>
        La presente Política de Cookies puede actualizarse en función de exigencias legales o técnicas. Se recomienda al usuario revisarla periódicamente y la de los proveedores.
      </p>
    </section>

    <p style={{ fontSize: "14px", marginTop: "10px",  color: "rgba(0, 0, 0, 0.6)" }}>Fecha de actualización 01/08/2025</p>
  </div>
);

export default UsoCookies;
